// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, type MutationOptions, queryOptions } from '@tanstack/angular-query-experimental';

import { client } from '../client.gen';
import {
  analyzeFailedTest,
  approve,
  cancelDeployment,
  cancelWorkflowRun,
  createReleaseCandidate,
  createTestType,
  createWorkflowGroup,
  decline,
  deleteReleaseCandidateByName,
  deleteTestType,
  deleteWorkflowGroup,
  deployToEnvironment,
  evaluate,
  extendEnvironmentLock,
  generateReleaseNotes,
  getActivityHistoryByEnvironmentId,
  getActivityHistoryByPullRequestId,
  getActivityHistoryByRepositoryIdAndBranchName,
  getAllBranches,
  getAllDeployments,
  getAllEnabledEnvironments,
  getAllEnvironments,
  getAllReleaseInfos,
  getAllRepositories,
  getAllTestTypes,
  getAllWorkflows,
  getBranchByRepositoryIdAndName,
  getCommitByRepositoryIdAndName,
  getCommitsSinceLastReleaseCandidate,
  getDeploymentById,
  getDeploymentReadiness,
  getDeploymentsByEnvironmentId,
  getDeploymentWorkflowConfig,
  getEnvironmentById,
  getEnvironmentReviewers,
  getEnvironmentsByRepositoryId,
  getEnvironmentsByUserLocking,
  getFailureAnalysisUsage,
  getFlakinessScores,
  getFlakyTestsOverview,
  getGitRepoSettings,
  getGroupsWithWorkflows,
  getLatestCachedFailureAnalysis,
  getLatestDeploymentByEnvironmentId,
  getLatestTestResultsByBranch,
  getLatestTestResultsByPullRequestId,
  getLatestWorkflowRunsByBranchAndHeadCommit,
  getLatestWorkflowRunsByPullRequestIdAndHeadCommit,
  getLockHistoryByEnvironmentId,
  getNotificationPreferences,
  getPipelineByBranch,
  getPipelineByPullRequest,
  getPullRequestById,
  getPullRequestByRepositoryId,
  getPullRequestByRepositoryIdAndNumber,
  getPullRequestFilterOptionsByRepositoryId,
  getPullRequests,
  getReleaseInfoByName,
  getRepositoryById,
  getTestResultsByWorkflowRunId,
  getUserPermissions,
  getUserSettings,
  getWorkflowById,
  getWorkflowJobStatus,
  getWorkflowRunById,
  getWorkflowRunLogs,
  getWorkflowRuns,
  getWorkflowsByRepositoryId,
  getWorkflowsByState,
  healthCheck,
  lockEnvironment,
  myPendingApprovals,
  type Options,
  publishReleaseDraft,
  reconcilePullRequestState,
  reRunFailedJobs,
  reRunWorkflow,
  rotateSecret,
  setBranchPinnedByRepositoryIdAndNameAndUserId,
  setPrPinnedByNumber,
  syncEnvironments,
  syncWorkflowsByRepositoryId,
  unlockEnvironment,
  update,
  updateEnvironment,
  updateGitRepoSettings,
  updateNotificationPreferences,
  updateReleaseName,
  updateReleaseNotes,
  updateTestType,
  updateUserSettings,
  updateWorkflowGroups,
  updateWorkflowLabel,
  upsertDeploymentWorkflowConfig,
} from '../sdk.gen';
import type {
  AnalyzeFailedTestData,
  AnalyzeFailedTestError,
  AnalyzeFailedTestResponse,
  ApproveData,
  ApproveError,
  ApproveResponse,
  CancelDeploymentData,
  CancelDeploymentError,
  CancelDeploymentResponse,
  CancelWorkflowRunData,
  CancelWorkflowRunError,
  CreateReleaseCandidateData,
  CreateReleaseCandidateError,
  CreateReleaseCandidateResponse,
  CreateTestTypeData,
  CreateTestTypeError,
  CreateTestTypeResponse,
  CreateWorkflowGroupData,
  CreateWorkflowGroupError,
  CreateWorkflowGroupResponse,
  DeclineData,
  DeclineError,
  DeclineResponse,
  DeleteReleaseCandidateByNameData,
  DeleteReleaseCandidateByNameError,
  DeleteReleaseCandidateByNameResponse,
  DeleteTestTypeData,
  DeleteTestTypeError,
  DeleteTestTypeResponse,
  DeleteWorkflowGroupData,
  DeleteWorkflowGroupError,
  DeployToEnvironmentData,
  DeployToEnvironmentError,
  DeployToEnvironmentResponse,
  EvaluateData,
  EvaluateError,
  ExtendEnvironmentLockData,
  ExtendEnvironmentLockError,
  ExtendEnvironmentLockResponse,
  GenerateReleaseNotesData,
  GenerateReleaseNotesError,
  GenerateReleaseNotesResponse,
  GetActivityHistoryByEnvironmentIdData,
  GetActivityHistoryByEnvironmentIdError,
  GetActivityHistoryByEnvironmentIdResponse,
  GetActivityHistoryByPullRequestIdData,
  GetActivityHistoryByPullRequestIdError,
  GetActivityHistoryByPullRequestIdResponse,
  GetActivityHistoryByRepositoryIdAndBranchNameData,
  GetActivityHistoryByRepositoryIdAndBranchNameError,
  GetActivityHistoryByRepositoryIdAndBranchNameResponse,
  GetAllBranchesData,
  GetAllBranchesError,
  GetAllBranchesResponse,
  GetAllDeploymentsData,
  GetAllDeploymentsError,
  GetAllDeploymentsResponse,
  GetAllEnabledEnvironmentsData,
  GetAllEnabledEnvironmentsError,
  GetAllEnabledEnvironmentsResponse,
  GetAllEnvironmentsData,
  GetAllEnvironmentsError,
  GetAllEnvironmentsResponse,
  GetAllReleaseInfosData,
  GetAllReleaseInfosError,
  GetAllReleaseInfosResponse,
  GetAllRepositoriesData,
  GetAllRepositoriesError,
  GetAllRepositoriesResponse,
  GetAllTestTypesData,
  GetAllTestTypesError,
  GetAllTestTypesResponse,
  GetAllWorkflowsData,
  GetAllWorkflowsError,
  GetAllWorkflowsResponse,
  GetBranchByRepositoryIdAndNameData,
  GetBranchByRepositoryIdAndNameError,
  GetBranchByRepositoryIdAndNameResponse,
  GetCommitByRepositoryIdAndNameData,
  GetCommitByRepositoryIdAndNameError,
  GetCommitByRepositoryIdAndNameResponse,
  GetCommitsSinceLastReleaseCandidateData,
  GetCommitsSinceLastReleaseCandidateError,
  GetCommitsSinceLastReleaseCandidateResponse,
  GetDeploymentByIdData,
  GetDeploymentByIdError,
  GetDeploymentByIdResponse,
  GetDeploymentReadinessData,
  GetDeploymentReadinessError,
  GetDeploymentReadinessResponse,
  GetDeploymentsByEnvironmentIdData,
  GetDeploymentsByEnvironmentIdError,
  GetDeploymentsByEnvironmentIdResponse,
  GetDeploymentWorkflowConfigData,
  GetDeploymentWorkflowConfigError,
  GetDeploymentWorkflowConfigResponse,
  GetEnvironmentByIdData,
  GetEnvironmentByIdError,
  GetEnvironmentByIdResponse,
  GetEnvironmentReviewersData,
  GetEnvironmentReviewersError,
  GetEnvironmentReviewersResponse,
  GetEnvironmentsByRepositoryIdData,
  GetEnvironmentsByRepositoryIdError,
  GetEnvironmentsByRepositoryIdResponse,
  GetEnvironmentsByUserLockingData,
  GetEnvironmentsByUserLockingError,
  GetEnvironmentsByUserLockingResponse,
  GetFailureAnalysisUsageData,
  GetFailureAnalysisUsageError,
  GetFailureAnalysisUsageResponse,
  GetFlakinessScoresData,
  GetFlakinessScoresError,
  GetFlakinessScoresResponse,
  GetFlakyTestsOverviewData,
  GetFlakyTestsOverviewError,
  GetFlakyTestsOverviewResponse,
  GetGitRepoSettingsData,
  GetGitRepoSettingsError,
  GetGitRepoSettingsResponse,
  GetGroupsWithWorkflowsData,
  GetGroupsWithWorkflowsError,
  GetGroupsWithWorkflowsResponse,
  GetLatestCachedFailureAnalysisData,
  GetLatestCachedFailureAnalysisError,
  GetLatestCachedFailureAnalysisResponse,
  GetLatestDeploymentByEnvironmentIdData,
  GetLatestDeploymentByEnvironmentIdError,
  GetLatestDeploymentByEnvironmentIdResponse,
  GetLatestTestResultsByBranchData,
  GetLatestTestResultsByBranchError,
  GetLatestTestResultsByBranchResponse,
  GetLatestTestResultsByPullRequestIdData,
  GetLatestTestResultsByPullRequestIdError,
  GetLatestTestResultsByPullRequestIdResponse,
  GetLatestWorkflowRunsByBranchAndHeadCommitData,
  GetLatestWorkflowRunsByBranchAndHeadCommitError,
  GetLatestWorkflowRunsByBranchAndHeadCommitResponse,
  GetLatestWorkflowRunsByPullRequestIdAndHeadCommitData,
  GetLatestWorkflowRunsByPullRequestIdAndHeadCommitError,
  GetLatestWorkflowRunsByPullRequestIdAndHeadCommitResponse,
  GetLockHistoryByEnvironmentIdData,
  GetLockHistoryByEnvironmentIdError,
  GetLockHistoryByEnvironmentIdResponse,
  GetNotificationPreferencesData,
  GetNotificationPreferencesError,
  GetNotificationPreferencesResponse,
  GetPipelineByBranchData,
  GetPipelineByBranchError,
  GetPipelineByBranchResponse,
  GetPipelineByPullRequestData,
  GetPipelineByPullRequestError,
  GetPipelineByPullRequestResponse,
  GetPullRequestByIdData,
  GetPullRequestByIdError,
  GetPullRequestByIdResponse,
  GetPullRequestByRepositoryIdAndNumberData,
  GetPullRequestByRepositoryIdAndNumberError,
  GetPullRequestByRepositoryIdAndNumberResponse,
  GetPullRequestByRepositoryIdData,
  GetPullRequestByRepositoryIdError,
  GetPullRequestByRepositoryIdResponse,
  GetPullRequestFilterOptionsByRepositoryIdData,
  GetPullRequestFilterOptionsByRepositoryIdError,
  GetPullRequestFilterOptionsByRepositoryIdResponse,
  GetPullRequestsData,
  GetPullRequestsError,
  GetPullRequestsResponse,
  GetReleaseInfoByNameData,
  GetReleaseInfoByNameError,
  GetReleaseInfoByNameResponse,
  GetRepositoryByIdData,
  GetRepositoryByIdError,
  GetRepositoryByIdResponse,
  GetTestResultsByWorkflowRunIdData,
  GetTestResultsByWorkflowRunIdError,
  GetTestResultsByWorkflowRunIdResponse,
  GetUserPermissionsData,
  GetUserPermissionsError,
  GetUserPermissionsResponse,
  GetUserSettingsData,
  GetUserSettingsError,
  GetUserSettingsResponse,
  GetWorkflowByIdData,
  GetWorkflowByIdError,
  GetWorkflowByIdResponse,
  GetWorkflowJobStatusData,
  GetWorkflowJobStatusError,
  GetWorkflowJobStatusResponse,
  GetWorkflowRunByIdData,
  GetWorkflowRunByIdError,
  GetWorkflowRunByIdResponse,
  GetWorkflowRunLogsData,
  GetWorkflowRunLogsError,
  GetWorkflowRunLogsResponse,
  GetWorkflowRunsData,
  GetWorkflowRunsError,
  GetWorkflowRunsResponse,
  GetWorkflowsByRepositoryIdData,
  GetWorkflowsByRepositoryIdError,
  GetWorkflowsByRepositoryIdResponse,
  GetWorkflowsByStateData,
  GetWorkflowsByStateError,
  GetWorkflowsByStateResponse,
  HealthCheckData,
  HealthCheckError,
  HealthCheckResponse,
  LockEnvironmentData,
  LockEnvironmentError,
  LockEnvironmentResponse,
  MyPendingApprovalsData,
  MyPendingApprovalsError,
  MyPendingApprovalsResponse,
  PublishReleaseDraftData,
  PublishReleaseDraftError,
  ReconcilePullRequestStateData,
  ReconcilePullRequestStateError,
  ReconcilePullRequestStateResponse,
  ReRunFailedJobsData,
  ReRunFailedJobsError,
  ReRunWorkflowData,
  ReRunWorkflowError,
  RotateSecretData,
  RotateSecretError,
  RotateSecretResponse,
  SetBranchPinnedByRepositoryIdAndNameAndUserIdData,
  SetBranchPinnedByRepositoryIdAndNameAndUserIdError,
  SetPrPinnedByNumberData,
  SetPrPinnedByNumberError,
  SyncEnvironmentsData,
  SyncEnvironmentsError,
  SyncEnvironmentsResponse,
  SyncWorkflowsByRepositoryIdData,
  SyncWorkflowsByRepositoryIdError,
  UnlockEnvironmentData,
  UnlockEnvironmentError,
  UnlockEnvironmentResponse,
  UpdateData,
  UpdateEnvironmentData,
  UpdateEnvironmentError,
  UpdateEnvironmentResponse,
  UpdateError,
  UpdateGitRepoSettingsData,
  UpdateGitRepoSettingsError,
  UpdateGitRepoSettingsResponse,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesError,
  UpdateReleaseNameData,
  UpdateReleaseNameError,
  UpdateReleaseNotesData,
  UpdateReleaseNotesError,
  UpdateTestTypeData,
  UpdateTestTypeError,
  UpdateTestTypeResponse,
  UpdateUserSettingsData,
  UpdateUserSettingsError,
  UpdateWorkflowGroupsData,
  UpdateWorkflowGroupsError,
  UpdateWorkflowLabelData,
  UpdateWorkflowLabelError,
  UpsertDeploymentWorkflowConfigData,
  UpsertDeploymentWorkflowConfigError,
  UpsertDeploymentWorkflowConfigResponse,
} from '../types.gen';

export const updateWorkflowLabelMutation = (
  options?: Partial<Options<UpdateWorkflowLabelData>>
): MutationOptions<unknown, UpdateWorkflowLabelError, Options<UpdateWorkflowLabelData>> => {
  const mutationOptions: MutationOptions<unknown, UpdateWorkflowLabelError, Options<UpdateWorkflowLabelData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateWorkflowLabel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteTestTypeMutation = (
  options?: Partial<Options<DeleteTestTypeData>>
): MutationOptions<DeleteTestTypeResponse, DeleteTestTypeError, Options<DeleteTestTypeData>> => {
  const mutationOptions: MutationOptions<DeleteTestTypeResponse, DeleteTestTypeError, Options<DeleteTestTypeData>> = {
    mutationFn: async fnOptions => {
      const { data } = await deleteTestType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateTestTypeMutation = (
  options?: Partial<Options<UpdateTestTypeData>>
): MutationOptions<UpdateTestTypeResponse, UpdateTestTypeError, Options<UpdateTestTypeData>> => {
  const mutationOptions: MutationOptions<UpdateTestTypeResponse, UpdateTestTypeError, Options<UpdateTestTypeData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateTestType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getDeploymentWorkflowConfigQueryKey = (options: Options<GetDeploymentWorkflowConfigData>) => createQueryKey('getDeploymentWorkflowConfig', options);

export const getDeploymentWorkflowConfigOptions = (options: Options<GetDeploymentWorkflowConfigData>) =>
  queryOptions<GetDeploymentWorkflowConfigResponse, GetDeploymentWorkflowConfigError, GetDeploymentWorkflowConfigResponse, ReturnType<typeof getDeploymentWorkflowConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeploymentWorkflowConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeploymentWorkflowConfigQueryKey(options),
  });

export const upsertDeploymentWorkflowConfigMutation = (
  options?: Partial<Options<UpsertDeploymentWorkflowConfigData>>
): MutationOptions<UpsertDeploymentWorkflowConfigResponse, UpsertDeploymentWorkflowConfigError, Options<UpsertDeploymentWorkflowConfigData>> => {
  const mutationOptions: MutationOptions<UpsertDeploymentWorkflowConfigResponse, UpsertDeploymentWorkflowConfigError, Options<UpsertDeploymentWorkflowConfigData>> = {
    mutationFn: async fnOptions => {
      const { data } = await upsertDeploymentWorkflowConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getGitRepoSettingsQueryKey = (options: Options<GetGitRepoSettingsData>) => createQueryKey('getGitRepoSettings', options);

export const getGitRepoSettingsOptions = (options: Options<GetGitRepoSettingsData>) =>
  queryOptions<GetGitRepoSettingsResponse, GetGitRepoSettingsError, GetGitRepoSettingsResponse, ReturnType<typeof getGitRepoSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGitRepoSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGitRepoSettingsQueryKey(options),
  });

export const updateGitRepoSettingsMutation = (
  options?: Partial<Options<UpdateGitRepoSettingsData>>
): MutationOptions<UpdateGitRepoSettingsResponse, UpdateGitRepoSettingsError, Options<UpdateGitRepoSettingsData>> => {
  const mutationOptions: MutationOptions<UpdateGitRepoSettingsResponse, UpdateGitRepoSettingsError, Options<UpdateGitRepoSettingsData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateGitRepoSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateWorkflowGroupsMutation = (
  options?: Partial<Options<UpdateWorkflowGroupsData>>
): MutationOptions<unknown, UpdateWorkflowGroupsError, Options<UpdateWorkflowGroupsData>> => {
  const mutationOptions: MutationOptions<unknown, UpdateWorkflowGroupsError, Options<UpdateWorkflowGroupsData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateWorkflowGroups({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateReleaseNameMutation = (options?: Partial<Options<UpdateReleaseNameData>>): MutationOptions<unknown, UpdateReleaseNameError, Options<UpdateReleaseNameData>> => {
  const mutationOptions: MutationOptions<unknown, UpdateReleaseNameError, Options<UpdateReleaseNameData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateReleaseName({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateReleaseNotesMutation = (
  options?: Partial<Options<UpdateReleaseNotesData>>
): MutationOptions<unknown, UpdateReleaseNotesError, Options<UpdateReleaseNotesData>> => {
  const mutationOptions: MutationOptions<unknown, UpdateReleaseNotesError, Options<UpdateReleaseNotesData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateReleaseNotes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEnvironmentByIdQueryKey = (options: Options<GetEnvironmentByIdData>) => createQueryKey('getEnvironmentById', options);

export const getEnvironmentByIdOptions = (options: Options<GetEnvironmentByIdData>) =>
  queryOptions<GetEnvironmentByIdResponse, GetEnvironmentByIdError, GetEnvironmentByIdResponse, ReturnType<typeof getEnvironmentByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentByIdQueryKey(options),
  });

export const updateEnvironmentMutation = (
  options?: Partial<Options<UpdateEnvironmentData>>
): MutationOptions<UpdateEnvironmentResponse, UpdateEnvironmentError, Options<UpdateEnvironmentData>> => {
  const mutationOptions: MutationOptions<UpdateEnvironmentResponse, UpdateEnvironmentError, Options<UpdateEnvironmentData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateEnvironment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const unlockEnvironmentMutation = (
  options?: Partial<Options<UnlockEnvironmentData>>
): MutationOptions<UnlockEnvironmentResponse, UnlockEnvironmentError, Options<UnlockEnvironmentData>> => {
  const mutationOptions: MutationOptions<UnlockEnvironmentResponse, UnlockEnvironmentError, Options<UnlockEnvironmentData>> = {
    mutationFn: async fnOptions => {
      const { data } = await unlockEnvironment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const lockEnvironmentMutation = (
  options?: Partial<Options<LockEnvironmentData>>
): MutationOptions<LockEnvironmentResponse, LockEnvironmentError, Options<LockEnvironmentData>> => {
  const mutationOptions: MutationOptions<LockEnvironmentResponse, LockEnvironmentError, Options<LockEnvironmentData>> = {
    mutationFn: async fnOptions => {
      const { data } = await lockEnvironment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const extendEnvironmentLockMutation = (
  options?: Partial<Options<ExtendEnvironmentLockData>>
): MutationOptions<ExtendEnvironmentLockResponse, ExtendEnvironmentLockError, Options<ExtendEnvironmentLockData>> => {
  const mutationOptions: MutationOptions<ExtendEnvironmentLockResponse, ExtendEnvironmentLockError, Options<ExtendEnvironmentLockData>> = {
    mutationFn: async fnOptions => {
      const { data } = await extendEnvironmentLock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const reRunWorkflowMutation = (options?: Partial<Options<ReRunWorkflowData>>): MutationOptions<unknown, ReRunWorkflowError, Options<ReRunWorkflowData>> => {
  const mutationOptions: MutationOptions<unknown, ReRunWorkflowError, Options<ReRunWorkflowData>> = {
    mutationFn: async fnOptions => {
      const { data } = await reRunWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const reRunFailedJobsMutation = (options?: Partial<Options<ReRunFailedJobsData>>): MutationOptions<unknown, ReRunFailedJobsError, Options<ReRunFailedJobsData>> => {
  const mutationOptions: MutationOptions<unknown, ReRunFailedJobsError, Options<ReRunFailedJobsData>> = {
    mutationFn: async fnOptions => {
      const { data } = await reRunFailedJobs({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const cancelWorkflowRunMutation = (options?: Partial<Options<CancelWorkflowRunData>>): MutationOptions<unknown, CancelWorkflowRunError, Options<CancelWorkflowRunData>> => {
  const mutationOptions: MutationOptions<unknown, CancelWorkflowRunError, Options<CancelWorkflowRunData>> = {
    mutationFn: async fnOptions => {
      const { data } = await cancelWorkflowRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const syncWorkflowsByRepositoryIdMutation = (
  options?: Partial<Options<SyncWorkflowsByRepositoryIdData>>
): MutationOptions<unknown, SyncWorkflowsByRepositoryIdError, Options<SyncWorkflowsByRepositoryIdData>> => {
  const mutationOptions: MutationOptions<unknown, SyncWorkflowsByRepositoryIdError, Options<SyncWorkflowsByRepositoryIdData>> = {
    mutationFn: async fnOptions => {
      const { data } = await syncWorkflowsByRepositoryId({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getUserSettingsQueryKey = (options?: Options<GetUserSettingsData>) => createQueryKey('getUserSettings', options);

export const getUserSettingsOptions = (options?: Options<GetUserSettingsData>) =>
  queryOptions<GetUserSettingsResponse, GetUserSettingsError, GetUserSettingsResponse, ReturnType<typeof getUserSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserSettingsQueryKey(options),
  });

export const updateUserSettingsMutation = (
  options?: Partial<Options<UpdateUserSettingsData>>
): MutationOptions<unknown, UpdateUserSettingsError, Options<UpdateUserSettingsData>> => {
  const mutationOptions: MutationOptions<unknown, UpdateUserSettingsError, Options<UpdateUserSettingsData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateUserSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getNotificationPreferencesQueryKey = (options?: Options<GetNotificationPreferencesData>) => createQueryKey('getNotificationPreferences', options);

export const getNotificationPreferencesOptions = (options?: Options<GetNotificationPreferencesData>) =>
  queryOptions<GetNotificationPreferencesResponse, GetNotificationPreferencesError, GetNotificationPreferencesResponse, ReturnType<typeof getNotificationPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getNotificationPreferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getNotificationPreferencesQueryKey(options),
  });

export const updateNotificationPreferencesMutation = (
  options?: Partial<Options<UpdateNotificationPreferencesData>>
): MutationOptions<unknown, UpdateNotificationPreferencesError, Options<UpdateNotificationPreferencesData>> => {
  const mutationOptions: MutationOptions<unknown, UpdateNotificationPreferencesError, Options<UpdateNotificationPreferencesData>> = {
    mutationFn: async fnOptions => {
      const { data } = await updateNotificationPreferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFlakinessScoresMutation = (
  options?: Partial<Options<GetFlakinessScoresData>>
): MutationOptions<GetFlakinessScoresResponse, GetFlakinessScoresError, Options<GetFlakinessScoresData>> => {
  const mutationOptions: MutationOptions<GetFlakinessScoresResponse, GetFlakinessScoresError, Options<GetFlakinessScoresData>> = {
    mutationFn: async fnOptions => {
      const { data } = await getFlakinessScores({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAllTestTypesQueryKey = (options?: Options<GetAllTestTypesData>) => createQueryKey('getAllTestTypes', options);

export const getAllTestTypesOptions = (options?: Options<GetAllTestTypesData>) =>
  queryOptions<GetAllTestTypesResponse, GetAllTestTypesError, GetAllTestTypesResponse, ReturnType<typeof getAllTestTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllTestTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllTestTypesQueryKey(options),
  });

export const createTestTypeMutation = (
  options?: Partial<Options<CreateTestTypeData>>
): MutationOptions<CreateTestTypeResponse, CreateTestTypeError, Options<CreateTestTypeData>> => {
  const mutationOptions: MutationOptions<CreateTestTypeResponse, CreateTestTypeError, Options<CreateTestTypeData>> = {
    mutationFn: async fnOptions => {
      const { data } = await createTestType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const rotateSecretMutation = (options?: Partial<Options<RotateSecretData>>): MutationOptions<RotateSecretResponse, RotateSecretError, Options<RotateSecretData>> => {
  const mutationOptions: MutationOptions<RotateSecretResponse, RotateSecretError, Options<RotateSecretData>> = {
    mutationFn: async fnOptions => {
      const { data } = await rotateSecret({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createWorkflowGroupMutation = (
  options?: Partial<Options<CreateWorkflowGroupData>>
): MutationOptions<CreateWorkflowGroupResponse, CreateWorkflowGroupError, Options<CreateWorkflowGroupData>> => {
  const mutationOptions: MutationOptions<CreateWorkflowGroupResponse, CreateWorkflowGroupError, Options<CreateWorkflowGroupData>> = {
    mutationFn: async fnOptions => {
      const { data } = await createWorkflowGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const analyzeFailedTestMutation = (
  options?: Partial<Options<AnalyzeFailedTestData>>
): MutationOptions<AnalyzeFailedTestResponse, AnalyzeFailedTestError, Options<AnalyzeFailedTestData>> => {
  const mutationOptions: MutationOptions<AnalyzeFailedTestResponse, AnalyzeFailedTestError, Options<AnalyzeFailedTestData>> = {
    mutationFn: async fnOptions => {
      const { data } = await analyzeFailedTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteReleaseCandidateByNameMutation = (
  options?: Partial<Options<DeleteReleaseCandidateByNameData>>
): MutationOptions<DeleteReleaseCandidateByNameResponse, DeleteReleaseCandidateByNameError, Options<DeleteReleaseCandidateByNameData>> => {
  const mutationOptions: MutationOptions<DeleteReleaseCandidateByNameResponse, DeleteReleaseCandidateByNameError, Options<DeleteReleaseCandidateByNameData>> = {
    mutationFn: async fnOptions => {
      const { data } = await deleteReleaseCandidateByName({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAllReleaseInfosQueryKey = (options?: Options<GetAllReleaseInfosData>) => createQueryKey('getAllReleaseInfos', options);

export const getAllReleaseInfosOptions = (options?: Options<GetAllReleaseInfosData>) =>
  queryOptions<GetAllReleaseInfosResponse, GetAllReleaseInfosError, GetAllReleaseInfosResponse, ReturnType<typeof getAllReleaseInfosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllReleaseInfos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllReleaseInfosQueryKey(options),
  });

export const createReleaseCandidateMutation = (
  options?: Partial<Options<CreateReleaseCandidateData>>
): MutationOptions<CreateReleaseCandidateResponse, CreateReleaseCandidateError, Options<CreateReleaseCandidateData>> => {
  const mutationOptions: MutationOptions<CreateReleaseCandidateResponse, CreateReleaseCandidateError, Options<CreateReleaseCandidateData>> = {
    mutationFn: async fnOptions => {
      const { data } = await createReleaseCandidate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const publishReleaseDraftMutation = (
  options?: Partial<Options<PublishReleaseDraftData>>
): MutationOptions<unknown, PublishReleaseDraftError, Options<PublishReleaseDraftData>> => {
  const mutationOptions: MutationOptions<unknown, PublishReleaseDraftError, Options<PublishReleaseDraftData>> = {
    mutationFn: async fnOptions => {
      const { data } = await publishReleaseDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const generateReleaseNotesMutation = (
  options?: Partial<Options<GenerateReleaseNotesData>>
): MutationOptions<GenerateReleaseNotesResponse, GenerateReleaseNotesError, Options<GenerateReleaseNotesData>> => {
  const mutationOptions: MutationOptions<GenerateReleaseNotesResponse, GenerateReleaseNotesError, Options<GenerateReleaseNotesData>> = {
    mutationFn: async fnOptions => {
      const { data } = await generateReleaseNotes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const evaluateMutation = (options?: Partial<Options<EvaluateData>>): MutationOptions<unknown, EvaluateError, Options<EvaluateData>> => {
  const mutationOptions: MutationOptions<unknown, EvaluateError, Options<EvaluateData>> = {
    mutationFn: async fnOptions => {
      const { data } = await evaluate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getReleaseInfoByNameMutation = (
  options?: Partial<Options<GetReleaseInfoByNameData>>
): MutationOptions<GetReleaseInfoByNameResponse, GetReleaseInfoByNameError, Options<GetReleaseInfoByNameData>> => {
  const mutationOptions: MutationOptions<GetReleaseInfoByNameResponse, GetReleaseInfoByNameError, Options<GetReleaseInfoByNameData>> = {
    mutationFn: async fnOptions => {
      const { data } = await getReleaseInfoByName({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setPrPinnedByNumberMutation = (
  options?: Partial<Options<SetPrPinnedByNumberData>>
): MutationOptions<unknown, SetPrPinnedByNumberError, Options<SetPrPinnedByNumberData>> => {
  const mutationOptions: MutationOptions<unknown, SetPrPinnedByNumberError, Options<SetPrPinnedByNumberData>> = {
    mutationFn: async fnOptions => {
      const { data } = await setPrPinnedByNumber({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const reconcilePullRequestStateMutation = (
  options?: Partial<Options<ReconcilePullRequestStateData>>
): MutationOptions<ReconcilePullRequestStateResponse, ReconcilePullRequestStateError, Options<ReconcilePullRequestStateData>> => {
  const mutationOptions: MutationOptions<ReconcilePullRequestStateResponse, ReconcilePullRequestStateError, Options<ReconcilePullRequestStateData>> = {
    mutationFn: async fnOptions => {
      const { data } = await reconcilePullRequestState({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const syncEnvironmentsMutation = (
  options?: Partial<Options<SyncEnvironmentsData>>
): MutationOptions<SyncEnvironmentsResponse, SyncEnvironmentsError, Options<SyncEnvironmentsData>> => {
  const mutationOptions: MutationOptions<SyncEnvironmentsResponse, SyncEnvironmentsError, Options<SyncEnvironmentsData>> = {
    mutationFn: async fnOptions => {
      const { data } = await syncEnvironments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateMutation = (options?: Partial<Options<UpdateData>>): MutationOptions<unknown, UpdateError, Options<UpdateData>> => {
  const mutationOptions: MutationOptions<unknown, UpdateError, Options<UpdateData>> = {
    mutationFn: async fnOptions => {
      const { data } = await update({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const declineMutation = (options?: Partial<Options<DeclineData>>): MutationOptions<DeclineResponse, DeclineError, Options<DeclineData>> => {
  const mutationOptions: MutationOptions<DeclineResponse, DeclineError, Options<DeclineData>> = {
    mutationFn: async fnOptions => {
      const { data } = await decline({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const approveMutation = (options?: Partial<Options<ApproveData>>): MutationOptions<ApproveResponse, ApproveError, Options<ApproveData>> => {
  const mutationOptions: MutationOptions<ApproveResponse, ApproveError, Options<ApproveData>> = {
    mutationFn: async fnOptions => {
      const { data } = await approve({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deployToEnvironmentMutation = (
  options?: Partial<Options<DeployToEnvironmentData>>
): MutationOptions<DeployToEnvironmentResponse, DeployToEnvironmentError, Options<DeployToEnvironmentData>> => {
  const mutationOptions: MutationOptions<DeployToEnvironmentResponse, DeployToEnvironmentError, Options<DeployToEnvironmentData>> = {
    mutationFn: async fnOptions => {
      const { data } = await deployToEnvironment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const cancelDeploymentMutation = (
  options?: Partial<Options<CancelDeploymentData>>
): MutationOptions<CancelDeploymentResponse, CancelDeploymentError, Options<CancelDeploymentData>> => {
  const mutationOptions: MutationOptions<CancelDeploymentResponse, CancelDeploymentError, Options<CancelDeploymentData>> = {
    mutationFn: async fnOptions => {
      const { data } = await cancelDeployment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setBranchPinnedByRepositoryIdAndNameAndUserIdMutation = (
  options?: Partial<Options<SetBranchPinnedByRepositoryIdAndNameAndUserIdData>>
): MutationOptions<unknown, SetBranchPinnedByRepositoryIdAndNameAndUserIdError, Options<SetBranchPinnedByRepositoryIdAndNameAndUserIdData>> => {
  const mutationOptions: MutationOptions<unknown, SetBranchPinnedByRepositoryIdAndNameAndUserIdError, Options<SetBranchPinnedByRepositoryIdAndNameAndUserIdData>> = {
    mutationFn: async fnOptions => {
      const { data } = await setBranchPinnedByRepositoryIdAndNameAndUserId({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const healthCheckQueryKey = (options?: Options<HealthCheckData>) => createQueryKey('healthCheck', options);

export const healthCheckOptions = (options?: Options<HealthCheckData>) =>
  queryOptions<HealthCheckResponse, HealthCheckError, HealthCheckResponse, ReturnType<typeof healthCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthCheckQueryKey(options),
  });

export const getAllWorkflowsQueryKey = (options?: Options<GetAllWorkflowsData>) => createQueryKey('getAllWorkflows', options);

export const getAllWorkflowsOptions = (options?: Options<GetAllWorkflowsData>) =>
  queryOptions<GetAllWorkflowsResponse, GetAllWorkflowsError, GetAllWorkflowsResponse, ReturnType<typeof getAllWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllWorkflows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllWorkflowsQueryKey(options),
  });

export const getWorkflowByIdQueryKey = (options: Options<GetWorkflowByIdData>) => createQueryKey('getWorkflowById', options);

export const getWorkflowByIdOptions = (options: Options<GetWorkflowByIdData>) =>
  queryOptions<GetWorkflowByIdResponse, GetWorkflowByIdError, GetWorkflowByIdResponse, ReturnType<typeof getWorkflowByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowByIdQueryKey(options),
  });

export const getWorkflowsByStateQueryKey = (options: Options<GetWorkflowsByStateData>) => createQueryKey('getWorkflowsByState', options);

export const getWorkflowsByStateOptions = (options: Options<GetWorkflowsByStateData>) =>
  queryOptions<GetWorkflowsByStateResponse, GetWorkflowsByStateError, GetWorkflowsByStateResponse, ReturnType<typeof getWorkflowsByStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowsByState({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowsByStateQueryKey(options),
  });

export const getWorkflowRunsQueryKey = (options?: Options<GetWorkflowRunsData>) => createQueryKey('getWorkflowRuns', options);

export const getWorkflowRunsOptions = (options?: Options<GetWorkflowRunsData>) =>
  queryOptions<GetWorkflowRunsResponse, GetWorkflowRunsError, GetWorkflowRunsResponse, ReturnType<typeof getWorkflowRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowRunsQueryKey(options),
  });

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getWorkflowRunsInfiniteQueryKey = (options?: Options<GetWorkflowRunsData>): QueryKey<Options<GetWorkflowRunsData>> => createQueryKey('getWorkflowRuns', options, true);

export const getWorkflowRunsInfiniteOptions = (options?: Options<GetWorkflowRunsData>) => {
  const opts = infiniteQueryOptions<
    GetWorkflowRunsResponse,
    GetWorkflowRunsError,
    InfiniteData<GetWorkflowRunsResponse>,
    QueryKey<Options<GetWorkflowRunsData>>,
    number | Pick<QueryKey<Options<GetWorkflowRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetWorkflowRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getWorkflowRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getWorkflowRunsInfiniteQueryKey(options),
    }
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getWorkflowRunLogsQueryKey = (options: Options<GetWorkflowRunLogsData>) => createQueryKey('getWorkflowRunLogs', options);

export const getWorkflowRunLogsOptions = (options: Options<GetWorkflowRunLogsData>) =>
  queryOptions<GetWorkflowRunLogsResponse, GetWorkflowRunLogsError, GetWorkflowRunLogsResponse, ReturnType<typeof getWorkflowRunLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowRunLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowRunLogsQueryKey(options),
  });

export const getWorkflowRunByIdQueryKey = (options: Options<GetWorkflowRunByIdData>) => createQueryKey('getWorkflowRunById', options);

export const getWorkflowRunByIdOptions = (options: Options<GetWorkflowRunByIdData>) =>
  queryOptions<GetWorkflowRunByIdResponse, GetWorkflowRunByIdError, GetWorkflowRunByIdResponse, ReturnType<typeof getWorkflowRunByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowRunById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowRunByIdQueryKey(options),
  });

export const getWorkflowsByRepositoryIdQueryKey = (options: Options<GetWorkflowsByRepositoryIdData>) => createQueryKey('getWorkflowsByRepositoryId', options);

export const getWorkflowsByRepositoryIdOptions = (options: Options<GetWorkflowsByRepositoryIdData>) =>
  queryOptions<GetWorkflowsByRepositoryIdResponse, GetWorkflowsByRepositoryIdError, GetWorkflowsByRepositoryIdResponse, ReturnType<typeof getWorkflowsByRepositoryIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowsByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowsByRepositoryIdQueryKey(options),
  });

export const getLatestWorkflowRunsByPullRequestIdAndHeadCommitQueryKey = (options: Options<GetLatestWorkflowRunsByPullRequestIdAndHeadCommitData>) =>
  createQueryKey('getLatestWorkflowRunsByPullRequestIdAndHeadCommit', options);

export const getLatestWorkflowRunsByPullRequestIdAndHeadCommitOptions = (options: Options<GetLatestWorkflowRunsByPullRequestIdAndHeadCommitData>) =>
  queryOptions<
    GetLatestWorkflowRunsByPullRequestIdAndHeadCommitResponse,
    GetLatestWorkflowRunsByPullRequestIdAndHeadCommitError,
    GetLatestWorkflowRunsByPullRequestIdAndHeadCommitResponse,
    ReturnType<typeof getLatestWorkflowRunsByPullRequestIdAndHeadCommitQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestWorkflowRunsByPullRequestIdAndHeadCommit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestWorkflowRunsByPullRequestIdAndHeadCommitQueryKey(options),
  });

export const getLatestWorkflowRunsByBranchAndHeadCommitQueryKey = (options: Options<GetLatestWorkflowRunsByBranchAndHeadCommitData>) =>
  createQueryKey('getLatestWorkflowRunsByBranchAndHeadCommit', options);

export const getLatestWorkflowRunsByBranchAndHeadCommitOptions = (options: Options<GetLatestWorkflowRunsByBranchAndHeadCommitData>) =>
  queryOptions<
    GetLatestWorkflowRunsByBranchAndHeadCommitResponse,
    GetLatestWorkflowRunsByBranchAndHeadCommitError,
    GetLatestWorkflowRunsByBranchAndHeadCommitResponse,
    ReturnType<typeof getLatestWorkflowRunsByBranchAndHeadCommitQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestWorkflowRunsByBranchAndHeadCommit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestWorkflowRunsByBranchAndHeadCommitQueryKey(options),
  });

export const getUserPermissionsQueryKey = (options?: Options<GetUserPermissionsData>) => createQueryKey('getUserPermissions', options);

export const getUserPermissionsOptions = (options?: Options<GetUserPermissionsData>) =>
  queryOptions<GetUserPermissionsResponse, GetUserPermissionsError, GetUserPermissionsResponse, ReturnType<typeof getUserPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserPermissionsQueryKey(options),
  });

export const getTestResultsByWorkflowRunIdQueryKey = (options: Options<GetTestResultsByWorkflowRunIdData>) => createQueryKey('getTestResultsByWorkflowRunId', options);

export const getTestResultsByWorkflowRunIdOptions = (options: Options<GetTestResultsByWorkflowRunIdData>) =>
  queryOptions<
    GetTestResultsByWorkflowRunIdResponse,
    GetTestResultsByWorkflowRunIdError,
    GetTestResultsByWorkflowRunIdResponse,
    ReturnType<typeof getTestResultsByWorkflowRunIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTestResultsByWorkflowRunId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTestResultsByWorkflowRunIdQueryKey(options),
  });

export const getTestResultsByWorkflowRunIdInfiniteQueryKey = (options: Options<GetTestResultsByWorkflowRunIdData>): QueryKey<Options<GetTestResultsByWorkflowRunIdData>> =>
  createQueryKey('getTestResultsByWorkflowRunId', options, true);

export const getTestResultsByWorkflowRunIdInfiniteOptions = (options: Options<GetTestResultsByWorkflowRunIdData>) => {
  const opts = infiniteQueryOptions<
    GetTestResultsByWorkflowRunIdResponse,
    GetTestResultsByWorkflowRunIdError,
    InfiniteData<GetTestResultsByWorkflowRunIdResponse>,
    QueryKey<Options<GetTestResultsByWorkflowRunIdData>>,
    number | Pick<QueryKey<Options<GetTestResultsByWorkflowRunIdData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetTestResultsByWorkflowRunIdData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getTestResultsByWorkflowRunId({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getTestResultsByWorkflowRunIdInfiniteQueryKey(options),
    }
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getLatestTestResultsByPullRequestIdQueryKey = (options: Options<GetLatestTestResultsByPullRequestIdData>) =>
  createQueryKey('getLatestTestResultsByPullRequestId', options);

export const getLatestTestResultsByPullRequestIdOptions = (options: Options<GetLatestTestResultsByPullRequestIdData>) =>
  queryOptions<
    GetLatestTestResultsByPullRequestIdResponse,
    GetLatestTestResultsByPullRequestIdError,
    GetLatestTestResultsByPullRequestIdResponse,
    ReturnType<typeof getLatestTestResultsByPullRequestIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestTestResultsByPullRequestId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestTestResultsByPullRequestIdQueryKey(options),
  });

export const getLatestTestResultsByPullRequestIdInfiniteQueryKey = (
  options: Options<GetLatestTestResultsByPullRequestIdData>
): QueryKey<Options<GetLatestTestResultsByPullRequestIdData>> => createQueryKey('getLatestTestResultsByPullRequestId', options, true);

export const getLatestTestResultsByPullRequestIdInfiniteOptions = (options: Options<GetLatestTestResultsByPullRequestIdData>) => {
  const opts = infiniteQueryOptions<
    GetLatestTestResultsByPullRequestIdResponse,
    GetLatestTestResultsByPullRequestIdError,
    InfiniteData<GetLatestTestResultsByPullRequestIdResponse>,
    QueryKey<Options<GetLatestTestResultsByPullRequestIdData>>,
    number | Pick<QueryKey<Options<GetLatestTestResultsByPullRequestIdData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetLatestTestResultsByPullRequestIdData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLatestTestResultsByPullRequestId({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLatestTestResultsByPullRequestIdInfiniteQueryKey(options),
    }
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getFlakyTestsOverviewQueryKey = (options?: Options<GetFlakyTestsOverviewData>) => createQueryKey('getFlakyTestsOverview', options);

export const getFlakyTestsOverviewOptions = (options?: Options<GetFlakyTestsOverviewData>) =>
  queryOptions<GetFlakyTestsOverviewResponse, GetFlakyTestsOverviewError, GetFlakyTestsOverviewResponse, ReturnType<typeof getFlakyTestsOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFlakyTestsOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFlakyTestsOverviewQueryKey(options),
  });

export const getFlakyTestsOverviewInfiniteQueryKey = (options?: Options<GetFlakyTestsOverviewData>): QueryKey<Options<GetFlakyTestsOverviewData>> =>
  createQueryKey('getFlakyTestsOverview', options, true);

export const getFlakyTestsOverviewInfiniteOptions = (options?: Options<GetFlakyTestsOverviewData>) => {
  const opts = infiniteQueryOptions<
    GetFlakyTestsOverviewResponse,
    GetFlakyTestsOverviewError,
    InfiniteData<GetFlakyTestsOverviewResponse>,
    QueryKey<Options<GetFlakyTestsOverviewData>>,
    number | Pick<QueryKey<Options<GetFlakyTestsOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetFlakyTestsOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getFlakyTestsOverview({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getFlakyTestsOverviewInfiniteQueryKey(options),
    }
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getLatestTestResultsByBranchQueryKey = (options: Options<GetLatestTestResultsByBranchData>) => createQueryKey('getLatestTestResultsByBranch', options);

export const getLatestTestResultsByBranchOptions = (options: Options<GetLatestTestResultsByBranchData>) =>
  queryOptions<
    GetLatestTestResultsByBranchResponse,
    GetLatestTestResultsByBranchError,
    GetLatestTestResultsByBranchResponse,
    ReturnType<typeof getLatestTestResultsByBranchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestTestResultsByBranch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestTestResultsByBranchQueryKey(options),
  });

export const getLatestTestResultsByBranchInfiniteQueryKey = (options: Options<GetLatestTestResultsByBranchData>): QueryKey<Options<GetLatestTestResultsByBranchData>> =>
  createQueryKey('getLatestTestResultsByBranch', options, true);

export const getLatestTestResultsByBranchInfiniteOptions = (options: Options<GetLatestTestResultsByBranchData>) => {
  const opts = infiniteQueryOptions<
    GetLatestTestResultsByBranchResponse,
    GetLatestTestResultsByBranchError,
    InfiniteData<GetLatestTestResultsByBranchResponse>,
    QueryKey<Options<GetLatestTestResultsByBranchData>>,
    number | Pick<QueryKey<Options<GetLatestTestResultsByBranchData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetLatestTestResultsByBranchData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLatestTestResultsByBranch({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLatestTestResultsByBranchInfiniteQueryKey(options),
    }
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getFailureAnalysisUsageQueryKey = (options?: Options<GetFailureAnalysisUsageData>) => createQueryKey('getFailureAnalysisUsage', options);

export const getFailureAnalysisUsageOptions = (options?: Options<GetFailureAnalysisUsageData>) =>
  queryOptions<GetFailureAnalysisUsageResponse, GetFailureAnalysisUsageError, GetFailureAnalysisUsageResponse, ReturnType<typeof getFailureAnalysisUsageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFailureAnalysisUsage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFailureAnalysisUsageQueryKey(options),
  });

export const getGroupsWithWorkflowsQueryKey = (options: Options<GetGroupsWithWorkflowsData>) => createQueryKey('getGroupsWithWorkflows', options);

export const getGroupsWithWorkflowsOptions = (options: Options<GetGroupsWithWorkflowsData>) =>
  queryOptions<GetGroupsWithWorkflowsResponse, GetGroupsWithWorkflowsError, GetGroupsWithWorkflowsResponse, ReturnType<typeof getGroupsWithWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGroupsWithWorkflows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGroupsWithWorkflowsQueryKey(options),
  });

export const getAllRepositoriesQueryKey = (options?: Options<GetAllRepositoriesData>) => createQueryKey('getAllRepositories', options);

export const getAllRepositoriesOptions = (options?: Options<GetAllRepositoriesData>) =>
  queryOptions<GetAllRepositoriesResponse, GetAllRepositoriesError, GetAllRepositoriesResponse, ReturnType<typeof getAllRepositoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllRepositories({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllRepositoriesQueryKey(options),
  });

export const getRepositoryByIdQueryKey = (options: Options<GetRepositoryByIdData>) => createQueryKey('getRepositoryById', options);

export const getRepositoryByIdOptions = (options: Options<GetRepositoryByIdData>) =>
  queryOptions<GetRepositoryByIdResponse, GetRepositoryByIdError, GetRepositoryByIdResponse, ReturnType<typeof getRepositoryByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRepositoryById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRepositoryByIdQueryKey(options),
  });

export const getLatestCachedFailureAnalysisQueryKey = (options: Options<GetLatestCachedFailureAnalysisData>) => createQueryKey('getLatestCachedFailureAnalysis', options);

export const getLatestCachedFailureAnalysisOptions = (options: Options<GetLatestCachedFailureAnalysisData>) =>
  queryOptions<
    GetLatestCachedFailureAnalysisResponse,
    GetLatestCachedFailureAnalysisError,
    GetLatestCachedFailureAnalysisResponse,
    ReturnType<typeof getLatestCachedFailureAnalysisQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestCachedFailureAnalysis({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestCachedFailureAnalysisQueryKey(options),
  });

export const getCommitsSinceLastReleaseCandidateQueryKey = (options: Options<GetCommitsSinceLastReleaseCandidateData>) =>
  createQueryKey('getCommitsSinceLastReleaseCandidate', options);

export const getCommitsSinceLastReleaseCandidateOptions = (options: Options<GetCommitsSinceLastReleaseCandidateData>) =>
  queryOptions<
    GetCommitsSinceLastReleaseCandidateResponse,
    GetCommitsSinceLastReleaseCandidateError,
    GetCommitsSinceLastReleaseCandidateResponse,
    ReturnType<typeof getCommitsSinceLastReleaseCandidateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCommitsSinceLastReleaseCandidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCommitsSinceLastReleaseCandidateQueryKey(options),
  });

export const getPullRequestsQueryKey = (options?: Options<GetPullRequestsData>) => createQueryKey('getPullRequests', options);

export const getPullRequestsOptions = (options?: Options<GetPullRequestsData>) =>
  queryOptions<GetPullRequestsResponse, GetPullRequestsError, GetPullRequestsResponse, ReturnType<typeof getPullRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestsQueryKey(options),
  });

export const getPullRequestsInfiniteQueryKey = (options?: Options<GetPullRequestsData>): QueryKey<Options<GetPullRequestsData>> => createQueryKey('getPullRequests', options, true);

export const getPullRequestsInfiniteOptions = (options?: Options<GetPullRequestsData>) => {
  const opts = infiniteQueryOptions<
    GetPullRequestsResponse,
    GetPullRequestsError,
    InfiniteData<GetPullRequestsResponse>,
    QueryKey<Options<GetPullRequestsData>>,
    number | Pick<QueryKey<Options<GetPullRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetPullRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPullRequests({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getPullRequestsInfiniteQueryKey(options),
    }
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getPullRequestByIdQueryKey = (options: Options<GetPullRequestByIdData>) => createQueryKey('getPullRequestById', options);

export const getPullRequestByIdOptions = (options: Options<GetPullRequestByIdData>) =>
  queryOptions<GetPullRequestByIdResponse, GetPullRequestByIdError, GetPullRequestByIdResponse, ReturnType<typeof getPullRequestByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequestById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestByIdQueryKey(options),
  });

export const getPullRequestByRepositoryIdAndNumberQueryKey = (options: Options<GetPullRequestByRepositoryIdAndNumberData>) =>
  createQueryKey('getPullRequestByRepositoryIdAndNumber', options);

export const getPullRequestByRepositoryIdAndNumberOptions = (options: Options<GetPullRequestByRepositoryIdAndNumberData>) =>
  queryOptions<
    GetPullRequestByRepositoryIdAndNumberResponse,
    GetPullRequestByRepositoryIdAndNumberError,
    GetPullRequestByRepositoryIdAndNumberResponse,
    ReturnType<typeof getPullRequestByRepositoryIdAndNumberQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequestByRepositoryIdAndNumber({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestByRepositoryIdAndNumberQueryKey(options),
  });

export const getPullRequestFilterOptionsByRepositoryIdQueryKey = (options: Options<GetPullRequestFilterOptionsByRepositoryIdData>) =>
  createQueryKey('getPullRequestFilterOptionsByRepositoryId', options);

export const getPullRequestFilterOptionsByRepositoryIdOptions = (options: Options<GetPullRequestFilterOptionsByRepositoryIdData>) =>
  queryOptions<
    GetPullRequestFilterOptionsByRepositoryIdResponse,
    GetPullRequestFilterOptionsByRepositoryIdError,
    GetPullRequestFilterOptionsByRepositoryIdResponse,
    ReturnType<typeof getPullRequestFilterOptionsByRepositoryIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequestFilterOptionsByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestFilterOptionsByRepositoryIdQueryKey(options),
  });

export const getPullRequestByRepositoryIdQueryKey = (options: Options<GetPullRequestByRepositoryIdData>) => createQueryKey('getPullRequestByRepositoryId', options);

export const getPullRequestByRepositoryIdOptions = (options: Options<GetPullRequestByRepositoryIdData>) =>
  queryOptions<
    GetPullRequestByRepositoryIdResponse,
    GetPullRequestByRepositoryIdError,
    GetPullRequestByRepositoryIdResponse,
    ReturnType<typeof getPullRequestByRepositoryIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPullRequestByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPullRequestByRepositoryIdQueryKey(options),
  });

export const getPipelineByPullRequestQueryKey = (options: Options<GetPipelineByPullRequestData>) => createQueryKey('getPipelineByPullRequest', options);

export const getPipelineByPullRequestOptions = (options: Options<GetPipelineByPullRequestData>) =>
  queryOptions<GetPipelineByPullRequestResponse, GetPipelineByPullRequestError, GetPipelineByPullRequestResponse, ReturnType<typeof getPipelineByPullRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPipelineByPullRequest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPipelineByPullRequestQueryKey(options),
  });

export const getPipelineByBranchQueryKey = (options: Options<GetPipelineByBranchData>) => createQueryKey('getPipelineByBranch', options);

export const getPipelineByBranchOptions = (options: Options<GetPipelineByBranchData>) =>
  queryOptions<GetPipelineByBranchResponse, GetPipelineByBranchError, GetPipelineByBranchResponse, ReturnType<typeof getPipelineByBranchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPipelineByBranch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPipelineByBranchQueryKey(options),
  });

export const getAllEnvironmentsQueryKey = (options?: Options<GetAllEnvironmentsData>) => createQueryKey('getAllEnvironments', options);

export const getAllEnvironmentsOptions = (options?: Options<GetAllEnvironmentsData>) =>
  queryOptions<GetAllEnvironmentsResponse, GetAllEnvironmentsError, GetAllEnvironmentsResponse, ReturnType<typeof getAllEnvironmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllEnvironments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllEnvironmentsQueryKey(options),
  });

export const getEnvironmentReviewersQueryKey = (options: Options<GetEnvironmentReviewersData>) => createQueryKey('getEnvironmentReviewers', options);

export const getEnvironmentReviewersOptions = (options: Options<GetEnvironmentReviewersData>) =>
  queryOptions<GetEnvironmentReviewersResponse, GetEnvironmentReviewersError, GetEnvironmentReviewersResponse, ReturnType<typeof getEnvironmentReviewersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentReviewers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentReviewersQueryKey(options),
  });

export const getDeploymentReadinessQueryKey = (options: Options<GetDeploymentReadinessData>) => createQueryKey('getDeploymentReadiness', options);

export const getDeploymentReadinessOptions = (options: Options<GetDeploymentReadinessData>) =>
  queryOptions<GetDeploymentReadinessResponse, GetDeploymentReadinessError, GetDeploymentReadinessResponse, ReturnType<typeof getDeploymentReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeploymentReadiness({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeploymentReadinessQueryKey(options),
  });

export const getEnvironmentsByUserLockingQueryKey = (options?: Options<GetEnvironmentsByUserLockingData>) => createQueryKey('getEnvironmentsByUserLocking', options);

export const getEnvironmentsByUserLockingOptions = (options?: Options<GetEnvironmentsByUserLockingData>) =>
  queryOptions<
    GetEnvironmentsByUserLockingResponse,
    GetEnvironmentsByUserLockingError,
    GetEnvironmentsByUserLockingResponse,
    ReturnType<typeof getEnvironmentsByUserLockingQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentsByUserLocking({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentsByUserLockingQueryKey(options),
  });

export const getEnvironmentsByRepositoryIdQueryKey = (options: Options<GetEnvironmentsByRepositoryIdData>) => createQueryKey('getEnvironmentsByRepositoryId', options);

export const getEnvironmentsByRepositoryIdOptions = (options: Options<GetEnvironmentsByRepositoryIdData>) =>
  queryOptions<
    GetEnvironmentsByRepositoryIdResponse,
    GetEnvironmentsByRepositoryIdError,
    GetEnvironmentsByRepositoryIdResponse,
    ReturnType<typeof getEnvironmentsByRepositoryIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvironmentsByRepositoryId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnvironmentsByRepositoryIdQueryKey(options),
  });

export const getLockHistoryByEnvironmentIdQueryKey = (options: Options<GetLockHistoryByEnvironmentIdData>) => createQueryKey('getLockHistoryByEnvironmentId', options);

export const getLockHistoryByEnvironmentIdOptions = (options: Options<GetLockHistoryByEnvironmentIdData>) =>
  queryOptions<
    GetLockHistoryByEnvironmentIdResponse,
    GetLockHistoryByEnvironmentIdError,
    GetLockHistoryByEnvironmentIdResponse,
    ReturnType<typeof getLockHistoryByEnvironmentIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLockHistoryByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLockHistoryByEnvironmentIdQueryKey(options),
  });

export const getAllEnabledEnvironmentsQueryKey = (options?: Options<GetAllEnabledEnvironmentsData>) => createQueryKey('getAllEnabledEnvironments', options);

export const getAllEnabledEnvironmentsOptions = (options?: Options<GetAllEnabledEnvironmentsData>) =>
  queryOptions<GetAllEnabledEnvironmentsResponse, GetAllEnabledEnvironmentsError, GetAllEnabledEnvironmentsResponse, ReturnType<typeof getAllEnabledEnvironmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllEnabledEnvironments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllEnabledEnvironmentsQueryKey(options),
  });

export const getAllDeploymentsQueryKey = (options?: Options<GetAllDeploymentsData>) => createQueryKey('getAllDeployments', options);

export const getAllDeploymentsOptions = (options?: Options<GetAllDeploymentsData>) =>
  queryOptions<GetAllDeploymentsResponse, GetAllDeploymentsError, GetAllDeploymentsResponse, ReturnType<typeof getAllDeploymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllDeployments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllDeploymentsQueryKey(options),
  });

export const getDeploymentByIdQueryKey = (options: Options<GetDeploymentByIdData>) => createQueryKey('getDeploymentById', options);

export const getDeploymentByIdOptions = (options: Options<GetDeploymentByIdData>) =>
  queryOptions<GetDeploymentByIdResponse, GetDeploymentByIdError, GetDeploymentByIdResponse, ReturnType<typeof getDeploymentByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeploymentById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeploymentByIdQueryKey(options),
  });

export const getWorkflowJobStatusQueryKey = (options: Options<GetWorkflowJobStatusData>) => createQueryKey('getWorkflowJobStatus', options);

export const getWorkflowJobStatusOptions = (options: Options<GetWorkflowJobStatusData>) =>
  queryOptions<GetWorkflowJobStatusResponse, GetWorkflowJobStatusError, GetWorkflowJobStatusResponse, ReturnType<typeof getWorkflowJobStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowJobStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowJobStatusQueryKey(options),
  });

export const getActivityHistoryByRepositoryIdAndBranchNameQueryKey = (options: Options<GetActivityHistoryByRepositoryIdAndBranchNameData>) =>
  createQueryKey('getActivityHistoryByRepositoryIdAndBranchName', options);

export const getActivityHistoryByRepositoryIdAndBranchNameOptions = (options: Options<GetActivityHistoryByRepositoryIdAndBranchNameData>) =>
  queryOptions<
    GetActivityHistoryByRepositoryIdAndBranchNameResponse,
    GetActivityHistoryByRepositoryIdAndBranchNameError,
    GetActivityHistoryByRepositoryIdAndBranchNameResponse,
    ReturnType<typeof getActivityHistoryByRepositoryIdAndBranchNameQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActivityHistoryByRepositoryIdAndBranchName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActivityHistoryByRepositoryIdAndBranchNameQueryKey(options),
  });

export const getActivityHistoryByPullRequestIdQueryKey = (options: Options<GetActivityHistoryByPullRequestIdData>) => createQueryKey('getActivityHistoryByPullRequestId', options);

export const getActivityHistoryByPullRequestIdOptions = (options: Options<GetActivityHistoryByPullRequestIdData>) =>
  queryOptions<
    GetActivityHistoryByPullRequestIdResponse,
    GetActivityHistoryByPullRequestIdError,
    GetActivityHistoryByPullRequestIdResponse,
    ReturnType<typeof getActivityHistoryByPullRequestIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActivityHistoryByPullRequestId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActivityHistoryByPullRequestIdQueryKey(options),
  });

export const myPendingApprovalsQueryKey = (options?: Options<MyPendingApprovalsData>) => createQueryKey('myPendingApprovals', options);

export const myPendingApprovalsOptions = (options?: Options<MyPendingApprovalsData>) =>
  queryOptions<MyPendingApprovalsResponse, MyPendingApprovalsError, MyPendingApprovalsResponse, ReturnType<typeof myPendingApprovalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await myPendingApprovals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: myPendingApprovalsQueryKey(options),
  });

export const getDeploymentsByEnvironmentIdQueryKey = (options: Options<GetDeploymentsByEnvironmentIdData>) => createQueryKey('getDeploymentsByEnvironmentId', options);

export const getDeploymentsByEnvironmentIdOptions = (options: Options<GetDeploymentsByEnvironmentIdData>) =>
  queryOptions<
    GetDeploymentsByEnvironmentIdResponse,
    GetDeploymentsByEnvironmentIdError,
    GetDeploymentsByEnvironmentIdResponse,
    ReturnType<typeof getDeploymentsByEnvironmentIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeploymentsByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeploymentsByEnvironmentIdQueryKey(options),
  });

export const getLatestDeploymentByEnvironmentIdQueryKey = (options: Options<GetLatestDeploymentByEnvironmentIdData>) =>
  createQueryKey('getLatestDeploymentByEnvironmentId', options);

export const getLatestDeploymentByEnvironmentIdOptions = (options: Options<GetLatestDeploymentByEnvironmentIdData>) =>
  queryOptions<
    GetLatestDeploymentByEnvironmentIdResponse,
    GetLatestDeploymentByEnvironmentIdError,
    GetLatestDeploymentByEnvironmentIdResponse,
    ReturnType<typeof getLatestDeploymentByEnvironmentIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestDeploymentByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestDeploymentByEnvironmentIdQueryKey(options),
  });

export const getActivityHistoryByEnvironmentIdQueryKey = (options: Options<GetActivityHistoryByEnvironmentIdData>) => createQueryKey('getActivityHistoryByEnvironmentId', options);

export const getActivityHistoryByEnvironmentIdOptions = (options: Options<GetActivityHistoryByEnvironmentIdData>) =>
  queryOptions<
    GetActivityHistoryByEnvironmentIdResponse,
    GetActivityHistoryByEnvironmentIdError,
    GetActivityHistoryByEnvironmentIdResponse,
    ReturnType<typeof getActivityHistoryByEnvironmentIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActivityHistoryByEnvironmentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActivityHistoryByEnvironmentIdQueryKey(options),
  });

export const getCommitByRepositoryIdAndNameQueryKey = (options: Options<GetCommitByRepositoryIdAndNameData>) => createQueryKey('getCommitByRepositoryIdAndName', options);

export const getCommitByRepositoryIdAndNameOptions = (options: Options<GetCommitByRepositoryIdAndNameData>) =>
  queryOptions<
    GetCommitByRepositoryIdAndNameResponse,
    GetCommitByRepositoryIdAndNameError,
    GetCommitByRepositoryIdAndNameResponse,
    ReturnType<typeof getCommitByRepositoryIdAndNameQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCommitByRepositoryIdAndName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCommitByRepositoryIdAndNameQueryKey(options),
  });

export const getAllBranchesQueryKey = (options?: Options<GetAllBranchesData>) => createQueryKey('getAllBranches', options);

export const getAllBranchesOptions = (options?: Options<GetAllBranchesData>) =>
  queryOptions<GetAllBranchesResponse, GetAllBranchesError, GetAllBranchesResponse, ReturnType<typeof getAllBranchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllBranches({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllBranchesQueryKey(options),
  });

export const getBranchByRepositoryIdAndNameQueryKey = (options: Options<GetBranchByRepositoryIdAndNameData>) => createQueryKey('getBranchByRepositoryIdAndName', options);

export const getBranchByRepositoryIdAndNameOptions = (options: Options<GetBranchByRepositoryIdAndNameData>) =>
  queryOptions<
    GetBranchByRepositoryIdAndNameResponse,
    GetBranchByRepositoryIdAndNameError,
    GetBranchByRepositoryIdAndNameResponse,
    ReturnType<typeof getBranchByRepositoryIdAndNameQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBranchByRepositoryIdAndName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBranchByRepositoryIdAndNameQueryKey(options),
  });

export const deleteWorkflowGroupMutation = (
  options?: Partial<Options<DeleteWorkflowGroupData>>
): MutationOptions<unknown, DeleteWorkflowGroupError, Options<DeleteWorkflowGroupData>> => {
  const mutationOptions: MutationOptions<unknown, DeleteWorkflowGroupError, Options<DeleteWorkflowGroupData>> = {
    mutationFn: async fnOptions => {
      const { data } = await deleteWorkflowGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
